import * as React from "react";

;
export const InactiveCheckboxUnchecked = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}><rect width={16} height={16} fill="#CFCDD3" rx={4} /></svg>;